import { render, staticRenderFns } from "./issuereceiveview.vue?vue&type=template&id=642c679c&scoped=true&"
import script from "./issuereceiveview.vue?vue&type=script&lang=js&"
export * from "./issuereceiveview.vue?vue&type=script&lang=js&"
import style0 from "./issuereceiveview.vue?vue&type=style&index=0&id=642c679c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c679c",
  null
  
)

export default component.exports